import { useQuery } from '@tanstack/react-query'
import { api } from '../../api/client'

/** FAQ entries — GET /help/faq. */
export function useFaq() {
  return useQuery({ queryKey: ['faq'], queryFn: () => api.faq() })
}
